var __decorate=this&&this.__decorate||function(e,t,s,i){var r,a=arguments.length,c=a<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,s):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)c=Reflect.decorate(e,t,s,i);else for(var o=e.length-1;o>=0;o--)(r=e[o])&&(c=(a<3?r(c):a>3?r(t,s,c):r(t,s))||c);return a>3&&c&&Object.defineProperty(t,s,c),c};import{OrElement as e}from"@openremote/or-element";import{css as t,html as s,unsafeCSS as i}from"lit";import{customElement as r,property as a,query as c}from"lit/decorators.js";import{styleMap as o}from"lit/directives/style-map.js";import{ifDefined as l}from"lit/directives/if-defined.js";import{MDCList as n}from"@material/list";import{DefaultColor8 as d,DefaultColor4 as m,Util as p}from"@openremote/core";import{i18next as h}from"@openremote/or-translate";let listStyle=require("@material/list/dist/mdc.list.css"),checkboxStyle=require("@material/checkbox/dist/mdc.checkbox.css");export class OrMwcListChangedEvent extends CustomEvent{constructor(e){super(OrMwcListChangedEvent.NAME,{detail:e,bubbles:!0,composed:!0})}}OrMwcListChangedEvent.NAME="or-mwc-list-changed";export var ListType;!function(e){e.PLAIN="PLAIN",e.SELECT="SELECT",e.RADIO="RADIO",e.MULTI_CHECKBOX="MULTI_CHECKBOX",e.MULTI_TICK="MULTI_TICK"}(ListType||(ListType={}));export function createListGroup(e){return s`
    <div class="mdc-list-group">
      ${e.map(e=>s`
          <h3 class="mdc-list-group__subheader">${e.heading}</h3>
          ${e.list}
        `)}
    </div>
  `}export function getListTemplate(e,t,i,r,a){switch(r=r||"listbox",e){case ListType.RADIO:r="radiogroup";break;case ListType.MULTI_CHECKBOX:r="group"}return s`
    <ul
      id="list"
      class="mdc-list${i?" mdc-list--two-line":""}"
      role="${l(r)}"
      @MDCList:action="${e=>a&&a(e)}"
      aria-hidden="true"
      aria-orientation="vertical"
      tabindex="-1"
    >
      ${t}
    </ul>
  `}export function getItemTemplate(e,t,i,r,a,c){let n,d,m;if(null===e)return s`<li role="separator" class="mdc-list-divider"></li>`;let p=r===ListType.MULTI_CHECKBOX||r===ListType.MULTI_TICK,u=e.value,_=r!==ListType.PLAIN&&i.length>0&&i.some(e=>e===u),v=void 0!==e.text?e.text:e.value,y=e.secondaryText,L="menuitem",I="",T="",x="",C=e.icon,f="mdc-list-item--selected";switch(a=a||e.translate,p&&r===ListType.MULTI_TICK&&(C=_?"checkbox-marked":"checkbox-blank-outline"),(r===ListType.MULTI_TICK||C)&&(T=s`
      <span class="mdc-list-item__graphic">
        <or-icon icon="${C}"></or-icon>
      </span>
    `),e.trailingIcon&&(x=s`
      <span class="mdc-list-item__meta" aria-hidden="true">
        <or-icon icon="${e.trailingIcon}"></or-icon>
      </span>
    `),r){case ListType.SELECT:n=_?"true":"false",m=_||(!i||0===i.length)&&0===t?"0":void 0,L="option";break;case ListType.RADIO:d=_?"true":"false",L="radio",T=s`
        <span class="mdc-list-item__graphic">
          <div class="mdc-radio">
            <input class="mdc-radio__native-control" id="radio-item-${t+1}" type="radio" value="${u}" />
            <div class="mdc-radio__background">
              <div class="mdc-radio__outer-circle"></div>
              <div class="mdc-radio__inner-circle"></div>
            </div>
          </div>
        </span>
      `;break;case ListType.MULTI_CHECKBOX:d=_?"true":"false",L="checkbox",T=s`
        <div class="mdc-checkbox">
          <input type="checkbox" class="mdc-checkbox__native-control" />
          <div class="mdc-checkbox__background">
            <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
              <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59" />
            </svg>
            <div class="mdc-checkbox__mixedmark"></div>
          </div>
        </div>
      `;break;case ListType.MULTI_TICK:d=_?"true":"false",f="mdc-list-item--selected"}return v&&(I=void 0!==y?s`
        <span class="mdc-list-item__text">
          <span class="mdc-list-item__primary-text"
            >${a&&v?s`<or-translate value="${v}"></or-translate>`:v}</span
          >
          <span class="mdc-list-item__secondary-text"
            >${a&&y?s`<or-translate value="${y}"></or-translate>`:y}</span
          >
        </span>
      `:r===ListType.RADIO?s`<label class="mdc-list-item__text" for="radio-item-${t+1}"
          >${a&&v?s`<or-translate value="${v}"></or-translate>`:v}</label
        >`:s`<span class="mdc-list-item__text" title="${a&&v?h.t(v):v}"
          >${a&&v?s`<or-translate value="${v}"></or-translate>`:v}</span
        >`),s`
    <li
      @click="${t=>{c&&c(t,e)}}"
      style="${e.styleMap?o(e.styleMap):""}"
      class="mdc-list-item ${_?f:""}"
      role="${l(L)}"
      tabindex="${l(m)}"
      aria-checked="${l(d)}"
      aria-selected="${l(n)}"
      data-value="${u}"
    >
      <span class="mdc-list-item__ripple"></span>
      ${T} ${I} ${x}
    </li>
  `}let style=t`
  :host {
    white-space: nowrap;
    --internal-or-mwc-input-color: var(--or-mwc-input-color, var(--or-app-color4, ${i(m)}));
    --internal-or-mwc-input-text-color: var(
      --or-mwc-input-text-color,
      var(--or-app-color8, ${i(d)})
    );

    --mdc-theme-primary: var(--internal-or-mwc-input-color);
    --mdc-theme-on-primary: var(--internal-or-mwc-input-text-color);
    --mdc-theme-secondary: var(--internal-or-mwc-input-color);
  }

  .mdc-list-item__graphic {
    margin-right: 16px;
  }

  a {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87);
  }
`,OrMwcList=class extends e{static get styles(){return[t`
        ${i(listStyle)}
      `,t`
        ${i(checkboxStyle)}
      `,style]}constructor(){super(),this.type=ListType.SELECT}disconnectedCallback(){super.disconnectedCallback(),this._mdcComponent&&(this._mdcComponent.destroy(),this._mdcComponent=void 0)}shouldUpdate(e){if(this._mdcComponent&&e.has("values")&&!p.objectsEqual(this.values,e.get("values"))){let e=this.values?Array.isArray(this.values)?this.values:[this.values]:[];this.setSelectedItems(this.values&&this.listItems?this.listItems.filter(t=>t&&(null==e?void 0:e.includes(t.value))):void 0)}return!0}render(){let e=this.listItems?s`${this.listItems.map((e,t)=>getItemTemplate(e,t,Array.isArray(this.values)?this.values:this.values?[this.values]:[],this.type))}`:s``,t=this.listItems&&this.listItems.some(e=>e&&!!e.secondaryText);return getListTemplate(this.type,e,t,void 0,e=>this._onSelected(e))}firstUpdated(e){super.firstUpdated(e),this._mdcElem&&(this._mdcComponent=new n(this._mdcElem),(this.type===ListType.SELECT||this.type===ListType.RADIO)&&(this._mdcComponent.singleSelection=!0))}get selectedItems(){if(!this._mdcComponent)return[];let e=Array.isArray(this._mdcComponent.selectedIndex)?this._mdcComponent.selectedIndex:[this._mdcComponent.selectedIndex],t=this.listItems?this.listItems.filter(e=>null!==e):[];return e.map(e=>t[e])}setSelectedItems(e){if(!this._mdcComponent||!this.listItems)return;if(!e){this._mdcComponent.selectedIndex=-1;return}let t=(!Array.isArray(e)?[e]:e).map(e=>"string"==typeof e?e:e.value),s=this.listItems.filter(e=>null!==e).reduce((e,s,i)=>(s&&t.includes(s.value)&&e.push(i),e),[]);this._mdcComponent.selectedIndex=this.type===ListType.MULTI_CHECKBOX?s:s.length>=1?s[0]:-1}_onSelected(e){this.values=this.selectedItems.map(e=>e.value),e.stopPropagation(),this.dispatchEvent(new OrMwcListChangedEvent(this.selectedItems))}};__decorate([a({type:Array})],OrMwcList.prototype,"listItems",void 0),__decorate([a({type:Array})],OrMwcList.prototype,"values",void 0),__decorate([a({type:String,attribute:!0})],OrMwcList.prototype,"type",void 0),__decorate([c("#wrapper")],OrMwcList.prototype,"_wrapperElem",void 0),__decorate([c("#list")],OrMwcList.prototype,"_mdcElem",void 0),OrMwcList=__decorate([r("or-mwc-list")],OrMwcList);export{OrMwcList};